<template>
    <div class="pb-5" style="z-index:10;">
        <b-button @click="clickCampaignName()" class="px-3 text-left border-0" block :variant="home_active_sytle==true?'icon-blue':'icon-gray'" style="height: 48px;">  Home </b-button> 
        <div v-if="template_in_progress_loaded==true" style="z-index:0">
            <Tree :data="template_contents" :prevent-select="false" :space="0" :indent="0" class="pb-2" :key="tree_key">
                <template v-slot="{data, store}">
                    <div v-if="!data.isDragPlaceholder && data.visible" @click.stop.prevent="pageGo(data.question_code)" :class="home_active_sytle==true?'':'question-active'">
                        <b-list-group-item @click="activateList(data.question_code)" :class="[is_active == data.question_code ? `node-level-${data._vm.level}-active`: '', 'd-flex justify-content-between align-items-center', `node-level-${data._vm.level}`]">
                            <div> {{ data.question_name }} <span v-if="data.is_completed=='true'"> <fa :id="`tooltip-target-${data.question_code}`" style="width:0.8rem;" :icon="['far', 'check-circle']" class="ml-2"></fa></span></div> 
                            <div>
                                <span v-if="data.number_of_comment!=0">
                                    <b-badge :variant="data.number_of_new_comment!=0? 'danger':'secondary'">{{ data.number_of_comment }}</b-badge>
                                </span>
                                <span v-if="data.children && data.children.length" @click.stop="store.toggleOpen(data)">
                                    <span v-if="data.open"><fa icon="angle-down"></fa></span>
                                    <span v-else><fa icon="angle-right"></fa></span>
                                </span>
                            </div>
                        </b-list-group-item>
                    </div>
                    <b-tooltip v-if="data.is_completed=='true'" :target="`tooltip-target-${data.question_code}`" triggers="hover" placement="right">
                        <b>제출한 항목입니다</b>
                    </b-tooltip>
                </template>
            </Tree>
            <!-- <div class="position-absolute print-aside"></div>
            <hr class="border-0 mb-4">
            <div :class="isIE?'d-none':'text-right pr-2'"> <print-to-pdf :btn_size="''" :btn_variant="'light-border'">질문지 및 답변 출력 <fa icon="print" class="ml-2"></fa></print-to-pdf></div>
            <div class="text-right pr-2"> <make-all-complete-button :btn_size="''" :btn_variant="'light-border'" class="mt-3">전체 답변 제출하기</make-all-complete-button></div>
             -->
             <!-- {{ $t('안녕하세요')}} -->
        </div>
        <div v-else>    
            <div class="px-3">
                <b-skeleton animation="wave" width="85%" height="30px" class="my-3"></b-skeleton>
                <b-skeleton animation="wave" width="70%"  height="30px" class="my-3"></b-skeleton>
                <b-skeleton animation="wave" width="70%"  height="30px" class="my-3"></b-skeleton>
                <b-skeleton animation="wave" width="70%" height="30px" class="my-3"></b-skeleton>
                <b-skeleton animation="wave" width="55%"  height="30px" class="my-3"></b-skeleton>
                <b-skeleton animation="wave" width="85%"  height="30px" class="my-3"></b-skeleton>
                <b-skeleton animation="wave" width="70%" height="30px" class="my-3"></b-skeleton>
                <b-skeleton animation="wave" width="70%"  height="30px" class="my-3"></b-skeleton>
                <b-skeleton animation="wave" width="70%"  height="30px" class="my-3"></b-skeleton>
            </div>
        </div>           
        <hr class="border-0 pb-5">
    </div>
</template>

<script>
import {DraggableTree} from 'vue-draggable-nested-tree'
import * as th from 'tree-helper'
import PrintToPDF from '../print_to_pdf/PrintToPDF'
import MakeAllCompleteButton from '@/components/main_layout/MakeAllCompleteButton'
import { mapState, mapMutations } from 'vuex'

export default {
    data(){
        return {
            is_active: 'false',
            is_sidebar_collapsed: false,
            tree_key: 21918481, //random number
            home_active_sytle: true
        }
    },
    props:{
    },
    computed: {
        ...mapState(['template_in_progress','template_in_progress_loaded', 'question_in_progress',  ]),
        template_code() {
            return this.template_in_progress.template_code
        },
        template_contents() {
            return this.template_in_progress.template_contents
        },
        isIE() {
            if ( (navigator.appName == 'Netscape' && navigator.userAgent.search('Trident') != -1) || (navigator.userAgent.toLowerCase().indexOf("msie") != -1) )
                {return true }
            else return false
        }
    },
    methods: {
        activateList(question_code){
            this.is_active = question_code
        },
        pageGo(question_code){
            //최초 이니시에이팅 완료 신호
            //this.initiating = false
            
            //자식노드가 있는 경우 클릭만으로도 접고 펴기
            //if(node.children && node.children.length) store.toggleOpen(node)

            //퀘스천 페이지 이동
            let temp_question_in_progress = { ...this.question_in_progress }
            temp_question_in_progress.question_code = question_code

            th.breadthFirstSearch(this.template_in_progress.template_contents,node => {
                if(node.question_code == question_code){
                    temp_question_in_progress.comment = node.comment
                    temp_question_in_progress.question_name = node.question_name
                    temp_question_in_progress.question_infobox = node.question_infobox
                    if(typeof(node.question_contents)=='string') {
                        temp_question_in_progress.question_contents = JSON.parse(node.question_contents)
                    }
                    else{
                        temp_question_in_progress.question_contents = node.question_contents
                    }
                    temp_question_in_progress.is_completed = node.is_completed
                }
            })
            this.$store.commit('update_question_in_progress', temp_question_in_progress)
            
            //console.log('퀘스천 콘텐츠')
            //console.log(temp_question_in_progress.question_contents)
            this.$store.dispatch('questions/readSubsInit', temp_question_in_progress.question_contents)
            .then( () => {
                Vue.nextTick( () => {
                    console.log('퀘스천 코드' + question_code)
                    this.$router.push( { name: 'Questions', params: { question_code: question_code }} )
                })
            })
            .catch(error => {
                console.log(error)
            })
        },
        clickCampaignName(){
            this.activateList('')
            this.$router.push({name:'ProviderPreface'})
        },
        collapseAll() {
          th.breadthFirstSearch(this.template_contents, node => {
            node.open = false
          })
        },
        handleMoveNextQuestion(new_question_code){
            this.activateList(new_question_code)
        },
        refreshTree(){
            this.tree_key += 10
        }
        // clickProgressRate(){            
        //     this.$router.push({name:'Progress'})
        // }
        
    },
    created(){
        EventBus.$on('move-next-question', this.handleMoveNextQuestion)
        EventBus.$on('refresh-tree', this.refreshTree) // from Question or Make Progress Complete All
    },
    updated(){
        //초기 상태면 모두 접기
        //if(this.initiating == true) this.collapseAll()
    },
    watch:{
        $route:{
            immediate: true,
            handler(to, from){
                if(to.path.includes('/questions')){
                    this.home_active_sytle = false
                }
                else if(to.path=='/provider_preface'){
                    this.home_active_sytle = true
                }
            }
        }
    },
    components: {
        Tree: DraggableTree,
        'print-to-pdf': PrintToPDF,
        MakeAllCompleteButton: MakeAllCompleteButton
    }

}
</script>

<style scoped>

.node-level-1,
.node-level-2,
.node-level-3,
.node-level-4{
    width: 100%;
    padding: 0.25rem 1.05rem;
    border: 0;
    border-radius: 0;
    letter-spacing: -0.2px;
    cursor: pointer
}
.node-level-1{
    color: var(--gray-900);
    font-weight: 500;
    padding: 0.8rem 1.05rem 0.6rem;
    margin-bottom: 0.2rem;
    background-color: var(--gray-200);   
    position: relative;
    border-bottom: 1px solid rgba(0,0,0,0);
}
.node-level-2,
.node-level-3{
    font-size: 0.9rem;
    color: var(--gray-600);
    background-color: var(--gray-200);   
}
.node-level-1:hover {
    color: var(--gray-600);
    border-bottom: 1px solid var(--gray-550);
}

.node-level-2:hover,
.node-level-3:hover,
.node-level-4:hover,
.node-level-2:focus,
.node-level-3:focus,
.node-level-4:focus{
    background-color: var(--gray-300);
}

.question-active > .node-level-1 {
    color: var(--gray-50);
    background-color: var(--gray-600); 
}
.question-active > .node-level-2,
.question-active > .node-level-3{
    color: var(--gray-300);
    background-color: var(--gray-600);   
}
.question-active > .node-level-1:hover {
    color: var(--gray-200);
    border-bottom: 1px solid var(--gray-400);
}
.question-active >.node-level-2:hover,
.question-active >.node-level-3:hover,
.question-active >.node-level-4:hover,
.question-active >.node-level-2:focus,
.question-active >.node-level-3:focus,
.question-active >.node-level-4:focus{
    background-color: var(--gray-550);
}
.question-active > .node-level-1-active,
.question-active > .node-level-2-active,
.question-active > .node-level-3-active,
.question-active > .node-level-4-active {
    background-color: var(--blue);
    color: var(--gray-100);
}
.question-active > .node-level-1-active:hover,
.question-active > .node-level-2-active:hover,
.question-active > .node-level-3-active:hover,
.question-active > .node-level-4-active:hover {
    background-color: var(--blue5);
    color: var(--gray-100);
}

.print-aside{
    top: 0;
    right:0; 
    margin-right:-44px;
    z-index: 1;
}
.print-aside:hover{
    top: 0;
    right:0; 
    margin-right:-195px;
}
</style>
